import ITask from './ITask';
import {
    OverlayFadeIn,
    OverlayFadeOut,
    Scale,
} from '../../System/Animation/Clip';
import {
    AwaitIterators,
    ConcatIterators,
    PlayAnimation,
} from '../../System/Animation/AnimationHelper';
import { delay } from './TaskQueue';
import WorldSystem from '../../System/World/WorldSystem';
import GameObject from '../../GameObject/GameObject';
import WorldHUDHandler from '../../System/UI/HUD/WorldHUDHandler';
import { RenderSystemEvent } from '../../System/Render/RenderSystem';
import OverlayComponent from '../../Component/UI/Overlay';
import Game from '../../Game';
import Point from '../Point';
import Text from '../../Prototype/Text';
import { Easing } from '@tweenjs/tween.js';
import { PlayerActions } from '../../State/Player/PlayerActions';
import { FTUXType } from "../../Player/PlayerProperty/Progress/FTUXType";
import { PopupID } from '../../State/UI/PopupID';
import { isSeasonPassTabActive } from 'System/UI/Menu/SeasonPassMenuHelper';

export default class QuestsFTUXTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<any> {
        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
        const { overlay, questButton, questButtonParent, text } = this.questButtonHighlight(system);

        yield* ConcatIterators([
            PlayAnimation(new OverlayFadeIn(overlay)),
            PlayAnimation(
                new Scale(text, {
                    startScale: Point.Zero,
                    endScale: Point.One,
                    duration: 250,
                    easing: Easing.Back.Out,
                })
            ),
            this.yieldUntilPopupOpened(),
            AwaitIterators([
                PlayAnimation(new OverlayFadeOut(overlay)),
                PlayAnimation(
                    new Scale(text, {
                        startScale: Point.One,
                        endScale: Point.Zero,
                        duration: 250,
                        easing: Easing.Back.In,
                    })
                ),
            ]),
        ]);
        questButtonParent.addChild(questButton);
        overlay.getComponent(OverlayComponent).preventInteraction = false;

        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);

        PlayerActions.setFTUXUnlocks([FTUXType.QUESTS]);
    }

    private *yieldUntilPopupOpened() {
        let state = Game.store.getState();
        while (state.UIState.popupID !== PopupID.QUEST_MENU) {
            yield* delay(100);
            state = Game.store.getState();
        }
    }

    private * yieldUntilSeasonPassSelected() {
        while (!isSeasonPassTabActive()) {
            yield* delay(100);
        }
    }

    private questButtonHighlight(system: WorldSystem) {
        const overlay = system.animator.getChildByName('overlay');
        const questButton = GameObject.findFirstByName(
            WorldHUDHandler.QUESTS_BTN_NAME
        );
        const questButtonParent = questButton.parent;

        const text = GameObject.Instantiate(Text, {
            relativePosition: new Point(0.5, 0.77),
            text: Game.locale.getText('QuestsFTUX'),
            style: Game.style.getStyle('quests.FTUX'),
            anchor: Point.Center,
            scale: Point.Zero,
        });
        system.animator.addChild(text);
        system.animator.addChild(questButton);

        overlay.getComponent(OverlayComponent).preventInteraction = true;

        return {
            overlay,
            questButton,
            questButtonParent,
            text,
        };
    }

    private seasonPassTabHighlight(system: WorldSystem) {
        const seasonPassoverlay = system.animator.getChildByName('overlay');
        const seasonPassButton = GameObject.findFirstByName(
            'tabSeasonPass'
        );
        const seasonPassButtonParent = GameObject.findFirstByName('tabContainerFront');

        const seasonPassText = GameObject.Instantiate(Text, {
            relativePosition: new Point(0.65, 0.3),
            text: Game.locale.getText('SeasonPassTutorialRewardsTab'),
            style: Game.style.getStyle('quests.FTUX'),
            anchor: Point.Center,
            scale: Point.Zero,
        });
        system.animator.addChild(seasonPassText);
        system.animator.addChild(seasonPassButton);

        seasonPassoverlay.getComponent(OverlayComponent).preventInteraction = true;

        return {
            seasonPassoverlay,
            seasonPassButton,
            seasonPassButtonParent,
            seasonPassText,
        };
    }
}
